import React, { createContext, useContext, useState } from "react";

type CartErrorContextProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  errors: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  setErrors?: (value: any) => void;
};

const CartErrorContext = createContext<CartErrorContextProps>({
  errors: [],
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
function CartErrorProvider({ children }: any) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  const [errors, setErrors] = useState<any>();
  const state = {
    errors,
    setErrors,
  };
  return (
    <CartErrorContext.Provider value={state}>
      {children}
    </CartErrorContext.Provider>
  );
}

function useCartErrorState() {
  const context = useContext(CartErrorContext);
  if (context === undefined) {
    throw new Error(
      "useCartErrorState must be used within a CartErrorProvider"
    );
  }
  return context;
}

export { CartErrorProvider, useCartErrorState };
